import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import SignaturePadControl from "../App/SignaturePadControl";

export function SignaturePad() {
  const [signatureImage, setSignatureImage] = useState<string>("");
  const handleSave = (signatureDataUrl: string) => {
    console.log("Signature data URL received in parent:", signatureDataUrl);
    setSignatureImage(signatureDataUrl);
  };

  return (
    <div className="page--data">
      <div className="flex-items">Signature Pad:</div>
      <div className="flex-items">
        <SignaturePadControl onSave={handleSave}></SignaturePadControl>
      </div>
      {signatureImage && (
        <div className="flex-items mar-t10">
          <span>Saved Signature:</span>
          <img src={signatureImage} alt="Signature" width={275} height={110} />
        </div>
      )}
    </div>
  );
}
